module.exports = __webpack_public_path__ + "static/media/azure_iot_hub.5d1fbf20.svg";